function resetFilterStatus() {
  return {
    type: 'RESET_FILTER_STATUS',
  };
}

function receiveMyJobsFilterUpdate(myJobsFilter) {
  return {
    type: 'RECEIVE_MYJOBS_FILTER_UPDATE',
    myJobsFilter,
  };
}

function receiveMyJobsTaskFilterUpdate(myJobsTaskFilter) {
  return {
    type: 'RECEIVE_MYJOBS_TASK_FILTER_UPDATE',
    myJobsTaskFilter,
  };
}

function receiveArchivesFilterUpdate(archiveFilter) {
  return {
    type: 'RECEIVE_ARCHIVES_FILTER_UPDATE',
    archiveFilter,
  };
}

function updateMyJobsFilter(query) {
  return (dispatch) => {
    dispatch(receiveMyJobsFilterUpdate(query));
  };
}

function updateMyJobsTaskFilter(query) {
  return (dispatch) => {
    dispatch(receiveMyJobsTaskFilterUpdate(query));
  };
}

function updateArchivesFilter(query) {
  return (dispatch) => {
    dispatch(receiveArchivesFilterUpdate(query));
  };
}

export default {
  resetFilterStatus,
  updateMyJobsFilter,
  updateMyJobsTaskFilter,
  updateArchivesFilter,
};
